import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompaniesAllowedStepsDialogComponent } from 'src/app/companies/companies-allowed-steps-dialog/companies-allowed-steps-dialog.component';
import { CompaniesArchiveDialogComponent } from 'src/app/companies/companies-archive-dialog/companies-archive-dialog.component';
import { CompaniesContractDialogComponent } from 'src/app/companies/companies-contract-dialog/companies-contract-dialog.component';
import { CompaniesEditDialogComponent } from 'src/app/companies/companies-edit-dialog/companies-edit-dialog.component';
import { CompaniesPaymentMethodsDialogComponent } from 'src/app/companies/companies-payment-methods-dialog/companies-payment-methods-dialog.component';
import { CompaniesSettingsDialogComponent } from 'src/app/companies/companies-settings-dialog/companies-settings-dialog.component';
import { CompaniesSubdomainDialogComponent } from 'src/app/companies/companies-subdomain-dialog/companies-subdomain-dialog.component';
import { CompaniesTicketDialogComponent } from 'src/app/companies/companies-ticket-dialog/companies-ticket-dialog.component';
import { CompaniesToggleDialogComponent } from 'src/app/companies/companies-toggle-dialog/companies-toggle-dialog.component';
import { CompaniesService, Company } from 'src/app/core/companies.service';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-company-details-header',
  templateUrl: './company-details-header.component.html',
  styleUrls: ['./company-details-header.component.scss'],
})
export class CompanyDetailsHeaderComponent {
  @Input() company_id?: string | null;

  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() tab_change: EventEmitter<string> = new EventEmitter<string>();

  company?: Company;
  is_read_running = false;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    private dialog_service: DialogService,
  ) {}

  ngOnInit(): void {
    this.readCompany(this.company_id as string);
  }

  onBackClick(): void {
    this.navigation_service.toCompanies();
  }

  readCompany(company_id: string): void {
    this.is_read_running = true;
    this.companies_service.readCompany(company_id).subscribe({
      next: response => {
        this.company = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  getShrinkedID(): string {
    return this.utils_service.getShrinkedID(this.company_id || '-');
  }

  onArchiveClick(): void {
    this.dialog_service
      .openDialog(CompaniesArchiveDialogComponent, {
        company_id: this.company?.company_id,
        company_business_name: this.company?.business_name,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onEditClick(): void {
    this.dialog_service
      .openDialog(CompaniesEditDialogComponent, { company: this.company })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onContractClick(): void {
    this.dialog_service
      .openDialog(CompaniesContractDialogComponent, { company: this.company })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onPaymentMethodsClick(): void {
    this.dialog_service
      .openDialog(CompaniesPaymentMethodsDialogComponent, { company_id: this.company?.company_id })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onEnableDisableClick(): void {
    this.dialog_service
      .openDialog(CompaniesToggleDialogComponent, { company: this.company })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result.success) {
          this.refresh.emit();
        }
        if (dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onAllowedStepsClick(): void {
    this.dialog_service
      .openDialog(CompaniesAllowedStepsDialogComponent, { company: this.company })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onTicketClick(): void {
    this.dialog_service
      .openDialog(CompaniesTicketDialogComponent, { company: this.company })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onSettingsClick(): void {
    this.dialog_service
      .openDialog(CompaniesSettingsDialogComponent, { company: this.company })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onSetCustomDomainClick(): void {
    this.dialog_service
      .openDialog(CompaniesSubdomainDialogComponent, { company_id: this.company?.company_id })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
}
